import React, { useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Play } from "lucide-react";
import "./css/JobBoards.css";

const JobBoards = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [videoPlaying, setVideoPlaying] = useState(false);

  return (
    <div className="job-boards-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="job-boards-content">
              <h2>Personalized Milestone Based Career Path</h2>
              <p>
                Based on your profile, we generate a customized career path with
                strategic milestones. Each milestone includes target dates and
                specific activities designed to build your skills and advance
                your career.
              </p>

              <ul className="feature-list">
                <li>
                  <span className="feature-icon">✓</span>
                  Exclusive access to CLIF AI Career Path
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  Mentor Connect and one-to-one guidance
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  Events, Webinars and many more...
                </li>
              </ul>

              <a href="/subscription" className="btn-primary try-free-btn">
                Get Started Now
              </a>
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="job-boards-image">
              <img src="./images/career_pathpng.png" alt="MileStones" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobBoards;
